import AnnualDataQualityMeasurementIntegrity from "./AnnualDataQualityMeasurementIntegrity";

const AnnualExecutiveQueuePerformanceSummary = (props) => (
  <AnnualDataQualityMeasurementIntegrity
    {...props}
    title="Annual Executive Queue Performance Summary"
    description="Board-ready annual queue performance summary covering demand, outcomes, waits, service time, peaks, and top operating exceptions."
    emptyTableText="No annual executive summary tables were supplied."
  />
);

export default AnnualExecutiveQueuePerformanceSummary;
